import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Refresh20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.25003 1H3.75003V4.6006C6.93282 1.12803 12.4239 0.756564 15.8337 4.16636C17.4445 5.77713 18.2501 7.8898 18.2501 9.99999L16.7501 9.99999C16.7501 8.27135 16.0912 6.54518 14.7731 5.22702C11.6867 2.14068 6.82767 2.94714 4.32204 6.25H9.00003V7.75H2.25003V1Z'
      fill='currentColor'
    />
    <path
      d='M15.6781 13.75C13.1725 17.0529 8.31336 17.8594 5.227 14.773C3.90884 13.4549 3.25 11.7287 3.25 10.0001L1.75 10.0001C1.75 12.1103 2.55556 14.2229 4.16634 15.8337C7.57613 19.2435 13.0672 18.872 16.25 15.3995V19H17.75V12.25L11 12.25L11 13.75L15.6781 13.75Z'
      fill='currentColor'
    />
  </Svg>
);

Refresh20.displayName = 'Refresh20';
export default Refresh20;
